import { apiClient } from "@/shared/api/client";

export interface SupplierCommissionDto {
    supplierId: string;
    supplierName: string;
    dailyCommissionType: string;
    dailyAmount: number;
    dailyApplyDate?: string;  // 백엔드에서 제공하는 경우
    weeklyCommissionType: string;
    weeklyAmount: number;
    weeklyApplyDate?: string;  // 백엔드에서 제공하는 경우
    startDate?: string;  // 시작일자
    endDate?: string;  // 종료일자
}

export interface SaveSupplierCommissionRequest {
    suppId: string;
    dailyCommissionType: string | null;
    dailyAmount: number | null;
    weeklyCommissionType: string | null;
    weeklyAmount: number | null;
    startDate: string;
    endDate: string | null;
    userId: string;
}

export interface CommissionHistoryItem {
    applyDate: string;
    period: string;
    commissionType: string;
    amount: number;
    modifier: string;
}

const BASE_PATH = '/api/v1/supplier-commissions';

export const supplierCommissionApi = {
    getAllSupplierCommissions: async (): Promise<SupplierCommissionDto[]> => {
        const response = await apiClient.get<SupplierCommissionDto[]>(BASE_PATH);
        return response.data;
    },

    saveSupplierCommission: async (request: SaveSupplierCommissionRequest): Promise<void> => {
        await apiClient.post(BASE_PATH, request);
    },

    getCommissionHistory: async (suppId: string): Promise<CommissionHistoryItem[]> => {
        const response = await apiClient.get<CommissionHistoryItem[]>(
            `${BASE_PATH}/${suppId}/history`
        );
        return response.data;
    }
};
